const readMoreButton = document.getElementById('read-more')
if (readMoreButton) {
  readMoreButton.addEventListener('click', () => {
    const productDescriptionAccordionButton = document.getElementById(
      'product-description'
    )

    productDescriptionAccordionButton.scrollIntoView({ behavior: 'smooth' })
    productDescriptionAccordionButton.click()
  })
}
